export default {
  SET_TOGGLE(state, payload) {
    state.toggle = payload;
  },
  SET_WHATSAPP_NUM(state, payload) {
    state.whatsappNumber = payload;
  },
  SET_WHATSAPP_TOGGLE(state, payload) {
    state.whatsappToggle= payload;
  },
};
